@if (isSelfAuthoring()) {
  <app-accordion-card
    [title]="'simulationBuilder.SKILLS_TITLE' | transloco"
    [subHeading]="'simulationBuilder.SKILLS_SUBTITLE' | transloco"
    [expanded]="true"
  >
    <qai-badge
      controls
      [shape]="'rectangle'"
      [kind]="'default'"
      [size]="'xsmall'"
      [label]="'simulationBuilder.SKILLS_WEIGHTING_LABEL' | transloco: { weight: skillsWeight() }"
    ></qai-badge>
    <div class="rubric-row">
      <div class="rubric-field">
        <qai-field [label]="'simulationBuilder.SKILLS_RUBRIC_LABEL' | transloco">
          <qai-floating-select
            [shape]="'rectangle'"
            [placeholder]="'simulationBuilder.SELECT_RUBRIC_PLACEHOLDER' | transloco"
            [options]="rubricOptions"
            [disabled]="readOnly"
            [allowDeselect]="true"
            [value]="skillPromptGroup?.get('rubric')?.value ?? ''"
            (valueChange)="onRubricChange($event)"
          ></qai-floating-select>
        </qai-field>
      </div>
      @if (selectedSkill()) {
        <div class="description-card">
          <p class="description-card__name">{{ selectedSkill()!.name }}</p>
          <p class="description-card__text">{{ selectedSkill()!.description }}</p>
        </div>
      }
    </div>
  </app-accordion-card>
} @else {
  <details-section [title]="'simulationBuilder.SKILLS_TITLE' | transloco" [showDetails]="false">
    <div class="container" [formGroup]="form">
      <div [formGroup]="skillPromptGroup">
        <qai-field [label]="skillPromptLabel">
          <textarea
            qai-textarea
            autosize
            qaiPasteClean
            [maxLines]="30"
            qaiTrimLeading
            formControlName="promptText"
          ></textarea>
        </qai-field>
      </div>
    </div>
  </details-section>
}
